import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export function filterNull<T>() {
  return (observable: Observable<T | undefined | null>) =>
    observable.pipe(
      filter((r) => r != null),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((r) => r!),
    );
}
